import { LoaderService, FillBarService, SoundService, ResizeService } from "shared/services";
import { FontsConfig } from "shared/config";
import { TextHelper } from "shared/helpers";
import { Game } from "screens";
import { LevelObject } from "shared/levels";
import { EventBus } from "shared/emmiter";
import { Main } from "screens/main";
import { MapScreen } from "screens/map/map";
import { UserService } from "./users.service";
import { Localizer } from "shared/localization";
import { IsMusicStartStorage } from "shared/storages";
import { OriginSize } from "shared/origin";
import { LanguageService } from "./language.service";
import config from "config";

export class PopupsService {
    public static isComplete: boolean = false;
    public static lose;
    public static win;
    public static reward;
    public static singIn;
    public static currentLevel: number = 15;
    public static newElements = [];
    public static popupY;

    public static init(): void {
        this.lose = new PIXI.spine.Spine(LoaderService.getResource('lose_popup').spineData);
        this.win = new PIXI.spine.Spine(LoaderService.getResource('win_popup').spineData);
        // this.reward = new PIXI.spine.Spine(LoaderService.getResource('reward_popup').spineData);

        // this.reward.alpha = 0;
        // this.reward.zIndex = 999999;
        this.win.alpha = 0;
        this.win.zIndex = 999999;
        this.lose.alpha = 0;
        this.lose.zIndex = 999999;

        // this.reward.x = Main.instance.app.view.width / 2;
        // this.reward.y = Main.instance.app.view.height / 2;
        this.lose.x = Main.instance.app.view.width / 2;
        this.lose.y = Main.instance.app.view.height / 2;
        this.win.x = Main.instance.app.view.width / 2;
        this.win.y = Main.instance.app.view.height / 2;

        this.popupY = Main.instance.app.view.height / 2;

        Main.instance.app.stage.addChild(this.lose, this.win);
        // Main.instance.app.stage.addChild(this.reward);
    }

    public static openRewardPopup(data): void {
        // this.currentLevel = level;
        const substate = document.getElementById('blackout_substate');
        substate.style.display = 'block';
        const animation = this.reward;

        const closeBtn = this.reward.children[6];
        closeBtn.interactive = true;
        animation.alpha = 1;
        if (animation.state.hasAnimation('reward_pop_up_animation')) {
            animation.state.setAnimation(0, 'reward_pop_up_animation', false);
        }

        closeBtn.on('pointerup', () => {
            this.rewardPopupClick(closeBtn, substate);
        })

        const textContainer = new PIXI.Container();
        textContainer.position.set(-250, 25)
        this.reward.addChild(textContainer);
        this.addRewardText({
            text: data.title,
            color: 0x222222,
            fontSize: 60,
            x: 0,
            y: 0,
        }, textContainer);
        this.addRewardText({
            text: data.model,
            color: 0x333333,
            fontSize: 40,
            x: 140,
            y: 100,
        }, textContainer);
        this.addRewardText({
            text: `${Localizer.languages[Localizer.locale].data.loc_pixi_discount}: ${data.discount}`,
            color: 0xFC2561,
            fontSize: 55,
            x: 100,
            y: 170,
        }, textContainer);
        this.newElements.push({
            parent: this.reward,
            child: textContainer,
        })
    }

    public static openWinPopup(level, score): void {
        this.isComplete = true;
        this.win.y = this.popupY;
        SoundService.stopAll();
        IsMusicStartStorage.isCanStart = false;
        SoundService.toggleWin(true, 1);
        score = Math.round(score);
        Game.instance.currentMechanic.calcTime();
        Game.instance.currentMechanic.interactive = false;
        Game.instance.blurScreen(true);
        const substate = document.getElementById('blackout_substate');
        substate.style.display = 'block';
        this.currentLevel = level;

        const animation = this.win;

        animation.alpha = 1;
        if (animation.state.hasAnimation('win_pop_up_animation')) {
            animation.state.setAnimation(0, 'win_pop_up_animation', false);
            animation.state.timeScale = 0.9;
        }
        const btn = this.win.children[14];
        btn.interactive = true;
        btn.on('pointerup', () => {
            this.winPopupBtnClick(btn, substate, level);
        });

        let completeStr = LanguageService.getTranslation('loc_win_popup');

        completeStr = completeStr.replace("%", this.currentLevel + '');

        this.win.children[18].children = [];
        this.win.children[19].children = [];

        this.addText(19, {
            text: LanguageService.getTranslation('loc_you_win'),
            color: 0xffffff,
            fontSize: 80,
            x: -150,
            y: -35,
            children: this.win.children,
        }, 'youWin', true);
        this.addText(18, {
            text: LanguageService.getTranslation('loc_done'),
            color: 0xffffff,
            fontSize: 60,
            x: -60,
            y: -35,
            children: this.win.children,
        }, 'done', true);
        this.addText(12, {
            text: completeStr,
            color: 0xFC2561,
            fontSize: 60,
            x: -230,
            y: -30,
            children: this.win.children,
        }, 'title');
        this.addText(15, {
            text: score,
            color: 0xFC2561,
            fontSize: 100,
            x: -170,
            y: -45,
            children: this.win.children,
        }, 'score');
        this.addText(15, {
            text: LanguageService.getTranslation('loc_pixi_pts'),
            color: 0x333333,
            fontSize: 40,
            x: 100,
            y: -30,
            children: this.win.children,
        }, 'text');

        UserService.changeUserScoreInLevel(level, score);

    }

    private static rewardPopupClick(btn, substate): void {
        Main.instance.map.map.interactive = true;
        this.reward.alpha = 0;
        substate.style.display = 'none';
    }

    private static async winPopupBtnClick(btn, substate, level) {
        this.isComplete = false;
        const resumeGame = document.getElementById('resume_game');

        const exitGame = document.getElementById('exit_game');
        const elCloneExit = exitGame.cloneNode(true);
        const elCloneResume = resumeGame.cloneNode(true);
        resumeGame.parentNode.replaceChild(elCloneResume, resumeGame);
        exitGame.parentNode.replaceChild(elCloneExit, exitGame);
        Main.instance.app.stage.removeChildren();
        const user = JSON.parse(localStorage.getItem('mbny_game_user'));
        const gameScreen = Game.instance.screen;
        // if(!config.guest) user.level = Number.parseInt(level);
        // else user.level = Number.parseInt(level) + 1;
        user.level = Number.parseInt(level) + 1;
        localStorage.setItem('mbny_game_user', JSON.stringify(user))
        LevelObject.tiles = [];
        LevelObject.helpersBlocks = [];
        LevelObject.selectedTile = { selected: false, map: null, column: 0, row: 0, tile: null };
        LevelObject.animations = [];
        const animation = Main.instance.app.stage.getChildByName('animation_container');
        Main.instance.app.stage.removeChild(animation);
        this.hideWinPopup();
        FillBarService.resetData();
        btn.interactive = false;
        gameScreen.removeChild(gameScreen.getChildByName('bar'));
        substate.style.display = 'none';
        if(!config.guest) await UserService.getUserData();
        Main.instance.openMap();
    }

    public static openSignInPopup(): void {
        this.singIn = new PIXI.spine.Spine(LoaderService.getResource('sign_in_popup').spineData);

        const login = document.getElementById('login');
        const mainPage = document.getElementById('main_page');
        const htmlContainer = document.getElementById('main');
        htmlContainer.style.display = 'flex';
        const resizeService = new ResizeService();
        const app = new PIXI.Application({
            width: OriginSize.width,
            height: OriginSize.height,
            transparent: true,
        });
        login.style.display = 'none';
        mainPage.style.display = 'none';
        htmlContainer.appendChild(app.view);
        window.addEventListener('resize', () => {
            resizeService.resizeScene(app);
        })

        app.stage.addChild(this.singIn);
        this.singIn.x = app.view.width / 2;
        this.singIn.y = app.view.height / 2;
        // SoundService.stopAll();
        // IsMusicStartStorage.isCanStart = false;
        const animation = this.singIn;

        const children = animation.children;

        children[2].interactive = true;
        children[2].buttonMode = true;
        children[2].on('pointerdown', () => {
            window.location.href = "https://www.maybelline.com/signin";
        })

        children[7].children = [];
        children[6].children = [];
        children[4].children = [];

        const textContainer = children[5];
        const text = textContainer.children[0];

        const infoText = new PIXI.Text(LanguageService.getTranslation('loc_login_info'), {
            fontFamily: FontsConfig.fonts.Neue_Helvetica_light,
            fill: 0x00000,
            fontSize: 20,
            letterSpacing: 2,
        });
        const newText = new PIXI.Text(LanguageService.getTranslation('loc_please_log_in'), {
            fontFamily: FontsConfig.fonts.Neue_Helvetica_light,
            fill: 0x00000,
            fontSize: 20,
            letterSpacing: 1,
        });
        const linkText = new PIXI.Text(LanguageService.getTranslation('loc_create_account'), {
            fontFamily: FontsConfig.fonts.Neue_Helvetica_light,
            fill: 0xfc2561,
            fontSize: 20,
            letterSpacing: 2,
        });
        const line = new PIXI.Graphics();
        line.beginFill(0xfc2561);
        line.drawRect(0, 0, 200, 2);
        line.endFill();
        line.name = 'darken'
        line.alpha = 1;

        line.y = -10;
        line.x = -23;
        infoText.x = -185;
        infoText.y = 10;
        newText.x = -185;
        newText.y = 15;
        linkText.x = -20;
        linkText.y = 15;
        newText.scale.y = -1;
        linkText.scale.y = -1;
        infoText.scale.y = -1;

        linkText.interactive = true;
        linkText.buttonMode = true;

        linkText.on('pointerdown', () => {
            window.location.href = "https://www.maybelline.com/signup";
        })

        this.addText(7, {
            text: LanguageService.getTranslation('loc_oops'),
            color: 0x000000,
            fontSize: 40,
            x: -50,
            y: -15,
            children: children,
        }, 'text');
        this.addText(6, {
            text: LanguageService.getTranslation('loc_login'),
            color: 0xffffff,
            fontSize: 20,
            x: -30,
            y: -13,
            children: children,
        }, 'text');

        textContainer.removeChild(text);
        textContainer.addChild(newText, linkText, line);
        children[4].addChild(infoText);
        animation.alpha = 1;
        if (animation.state.hasAnimation('sign_in_pop_up')) {
            animation.state.setAnimation(0, 'sign_in_pop_up', false);
        }
    }

    public static openLosePopup(level: number, score): void {
        this.isComplete = true;

        SoundService.stopAll();
        IsMusicStartStorage.isCanStart = false;
        SoundService.toggleLose(true, 1);
        this.currentLevel = level;
        const animation = this.lose;
        animation.alpha = 1;
        if (animation.state.hasAnimation('lose_pop_up_animation')) {
            animation.state.setAnimation(0, 'lose_pop_up_animation', false);
        }

        const btn = this.lose.children[11];
        btn.interactive = true;
        btn.buttonMode = true;
        EventBus.emit('game_end');
        btn.on('pointerup', () => {
            this.isComplete = false;

            const resumeGame = document.getElementById('resume_game');
            const elCloneResume = resumeGame.cloneNode(true);
            resumeGame.parentNode.replaceChild(elCloneResume, resumeGame);
            EventBus.emit('reset_game');
            Game.instance.destroy();
            btn.interactive = false;
            const animationContainer = Main.instance.app.stage.getChildByName('animation_container');

            const children = Main.instance.app.stage.children;

            // Main.instance.app.stage.des
            Main.instance.app.stage.removeChildren();
            Main.instance.app.stage.addChild(animationContainer);
            FillBarService.resetData();
            this.hideLosePopup();
            Main.instance.openMap();
        })

        let failedStr: string = LanguageService.getTranslation('loc_lose_popup');
        failedStr = failedStr.replace("%", this.currentLevel + '');
        this.lose.children[15].children = [];
        this.lose.children[14].children = [];

        this.addText(14, {
            text: LanguageService.getTranslation('loc_try_again'),
            color: 0xffffff,
            fontSize: 80,
            x: -165,
            y: -35,
            children: this.lose.children,
            align: 'center'
        }, 'tryAgain', true);
        this.addText(15, {
            text: LanguageService.getTranslation('loc_done'),
            color: 0xffffff,
            fontSize: 60,
            x: -60,
            y: -35,
            children: this.lose.children,
            align: 'center'
        }, 'done', true);
        this.addText(9, {
            text: failedStr,
            color: 0x666666,
            fontSize: 60,
            x: -180,
            y: -30,
            children: this.lose.children,
            align: 'center'
        }, 'title');
        this.addText(13, {
            text: score,
            color: 0xFC2561,
            fontSize: 100,
            x: -170,
            y: -135,
            children: this.lose.children,
            align: 'center'
        }, 'score');
        this.addText(13, {
            text: LanguageService.getTranslation('loc_pixi_pts'),
            color: 0x333333,
            fontSize: 40,
            x: 100,
            y: -105,
            children: this.lose.children,
            align: 'center'
        }, 'text');
    }

    private static addRewardText(option, container: PIXI.Container): void {
        const newText = new PIXI.Text(option.text);
        newText.zIndex = 99999;
        // newText.anchor.y = 1;
        // newText.scale.y *= -1;
        newText.x = option.x;
        newText.y = option.y;
        newText.style = new PIXI.TextStyle({
            fontFamily: FontsConfig.fonts.Helvetica_Neue,
            fill: option.color,
            fontSize: option.fontSize,
        });
        container.addChild(newText);
    }

    private static addText(index: number, option, type: string, isInCenter = false): void {
        const children = option.children;
        let text;
        if (type === 'score') {
            const score = Number.parseInt(option.text);
            text = score > 1000 ? TextHelper.numberWithCommas(score) : score;
            if (score < 10000) {
                option.x = -120;
            }
        } else {
            text = option.text;
        }

        const newText = new PIXI.Text(text);
        newText.zIndex = 99999;
        newText.anchor.y = 1;
        newText.scale.y *= -1;
        newText.x = option.x;
        newText.y = option.y;
        newText.style = new PIXI.TextStyle({
            fontFamily: FontsConfig.fonts.Helvetica_Neue,
            fill: option.color,
            fontSize: option.fontSize,
            align: 'center',
        });
        children[index].addChild(newText);
        this.newElements.push({
            parent: children[index],
            child: newText,
        });
        children[index].buttonMode = true;
        newText.buttonMode = true;
        children[index].cursor = "pointer";
        if (isInCenter) {
            newText.x = -(newText.width / 2);
        }

        this.sortContainerChildren(children[index]);
    }

    public static hideLosePopup(): void {
        Game.instance.blurScreen(false);
        this.deleteNewElements();
        this.lose.alpha = 0;
    }

    public static hideWinPopup(): void {
        Game.instance.blurScreen(false);
        this.deleteNewElements();
        this.win.alpha = 0;
    }

    public static hideRewardPopup(): void {
        Game.instance.blurScreen(false);
        this.deleteNewElements();
        this.reward.alpha = 0;
    }

    private static deleteNewElements(): void {
        const elements = this.newElements;
        for (let i = 0; i < elements.length; i++) {
            elements[i].parent.removeChild(elements[i].child);
        }
    }

    private static sortContainerChildren(container): void {
        container.children.sort((a, b) => {
            return a.zIndex - b.zIndex;
        });
    }
}